import { render } from "./RegistrationAlibaba.vue?vue&type=template&id=2197a59b&scoped=true"
import script from "./RegistrationAlibaba.vue?vue&type=script&lang=js"
export * from "./RegistrationAlibaba.vue?vue&type=script&lang=js"

import "./RegistrationAlibaba.vue?vue&type=style&index=0&id=2197a59b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2197a59b"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTooltip,QBanner,QIcon});
